module.exports = __webpack_public_path__ + "static/media/taget.50b77cb6.svg";